module.exports = {
  therapy: {
    patient: 'Pacjent',
    therapist: 'Terapeuta',
    printDate: 'Data wystawienia',
    practiceName: '@:sessions.pdfFields.practiceName',
  },
}
